import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Layout from "components/layout/Layout";
import CancelInfoSummarySection from "./sections/CancelInfoSummarySection";
import PaymentService, {
  CancelFeeCheckResponse,
} from "services/paymentService";
import LoadingSpinner from "components/LoadingSpinner";
import { FormattedMessage, useIntl } from "react-intl";
import OrderStatusSection from "components/order/OrderStatusSection";
import CustomButton from "components/button/CustomButton";
import { Stack } from "@mui/system";
import ProductInfoSection from "../history-detail-panel/sections/ProductInfoSection";
import { deleteMyOrders } from "app/myOrdersSlice";
import CancelTermSection from "../history-detail-panel/sections/CancelTermSection";
import { useAppDispatch } from "app/hooks";
import RelatedProduct from "../history-detail-panel/sections/RelatedProduct";
import { OrderType } from "types/orderType";
import { updatePoint } from "app/userSlice";
import UserService from "services/userService";

// 주문 취소 페이지
const OrderCancelPage = () => {
  const dispatch = useAppDispatch();
  const [cancelFeeDetails, setCancelFeeDetails] =
    useState<CancelFeeCheckResponse>();
  const [isLoading, setIsLoading] = useState(true); // 상세 내용 조회 여부
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation() as {
    state: { reservationDetails: OrderType };
  };
  const { reservationDetails } = location.state || {};
  const [isCancelProcessing, setIsCancelProcessing] = useState(false);
  // const [locationKeys, setLocationKeys] = useState([]);

  useEffect(() => {
    setIsLoading(true);
    if (reservationDetails && reservationDetails.orderId) {
      PaymentService.cancelFeeCheck(reservationDetails.orderId)
        .then((data) => {
          setCancelFeeDetails(data);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error("Error fetching cancel fee check details:", error);
        });
    }

    // [2024-02-15] 뒤로가기 버튼 대응 시도
    // return history.listen((location) => {
    //   if (history.action === "PUSH") {
    //     setLocationKeys([location.key]);
    //   }
    //
    //   if (history.action === "POP") {
    //     if (locationKeys[1] === location.key) {
    //       setLocationKeys(([_, ...keys]) => keys);
    //
    //       // 앞으로 가기
    //     } else {
    //       setLocationKeys((keys) => [location.key, ...keys]);
    //
    //       // 뒤로 가기
    //       navigate("/order-history");
    //       //history.push("/detail");
    //     }
    //   }
    // });
  }, [reservationDetails]);

  const handleCancelClick = async () => {
    //navigate(`/train/creditCancel`, { state: {}});
    let conf = window.confirm(
      intl.formatMessage({ id: "orders.cancelConfirm" })
    );
    if (!conf) {
      return;
    }

    setIsCancelProcessing(true);

    PaymentService.cancelReservation(reservationDetails.orderId)
      .then((data) => {
        if (data.result === "SUCCESS") {
          alert(intl.formatMessage({ id: "orders.cancelComplete" }));
          //navigate(`/order-details/${reservationDetails.orderId}`);
          dispatch(deleteMyOrders());
          UserService.getPoint().then((point) => {
            dispatch(updatePoint(point));
          });
          navigate(`/order-history`);
        } else {
          alert("주문 취소가 실패했습니다: " + data.errorMessage);
        }
      })
      .catch((error) => {
        alert("취소 과정 중 오류가 발생했습니다: " + error);
      })
      .finally(() => {
        setIsCancelProcessing(false);
      });
  };

  if (!reservationDetails) {
    return <div>주문 정보를 찾을 수 없습니다.</div>;
  }

  // Determine which sections to display based on order status
  const showPaymentInfo =
    reservationDetails.orderStatus === "PENDING" ||
    reservationDetails.orderStatus === "COMPLETE";
  const isPending = reservationDetails.orderStatus === "PENDING";
  const isPurchased = reservationDetails.orderStatus === "COMPLETE";

  return (
    <Layout text={intl.formatMessage({ id: "orders.cancelTitle" })}>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <Stack gap={2} sx={{ py: 2 }}>
          <OrderStatusSection order={reservationDetails} />
          <ProductInfoSection order={reservationDetails} />
          <RelatedProduct
            order={reservationDetails}
            cancelFee={cancelFeeDetails}
          />
          {showPaymentInfo &&
            cancelFeeDetails &&
            cancelFeeDetails.cancelFee != null &&
            cancelFeeDetails.cancelPrice != null && (
              <CancelInfoSummarySection cancelFee={cancelFeeDetails} />
            )}

          <CancelTermSection />
          {(isPurchased || isPending) && (
            <CustomButton
              color="error"
              onClick={handleCancelClick}
              disabled={isCancelProcessing}
            >
              <FormattedMessage id="orders.cancelButton" />
            </CustomButton>
          )}
          {isCancelProcessing && <LoadingSpinner overlap />}
        </Stack>
      )}
    </Layout>
  );
};

export default OrderCancelPage;
